import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import clsx from 'clsx';
import Slider from 'react-rangeslider/src/index';
import { capitalize, clamp } from 'react-rangeslider/src/utils';
import { propBool, propChildren } from '../../../helpers/custom-prop-types';
import HandleIcon from '../../Icon/Svg/HandleIcon';
const constants = {
    orientation: {
        horizontal: {
            coordinate: 'x',
            dimension: 'width',
            direction: 'left',
            reverseDirection: 'right',
        },
        vertical: {
            coordinate: 'y',
            dimension: 'height',
            direction: 'top',
            reverseDirection: 'bottom',
        },
    },
};
class InputRange extends Slider {
    constructor() {
        super(...arguments);
        this.fillRef = null;
        this.handleUpdate = () => {
            if (!this.slider) {
                // for shallow rendering
                return;
            }
            const { orientation } = this.props;
            const dimension = capitalize(constants.orientation[orientation].dimension);
            const sliderPos = this.slider[`offset${dimension}`];
            const handlePos = this.handle[`offset${dimension}`];
            this.setState({
                grab: handlePos / 2,
                limit: sliderPos,
            });
        };
        this.getPositionFromValue = (value) => {
            const { limit } = this.state;
            const { max, min, orientation, reverse } = this.props;
            const { paddingBottom, paddingLeft, paddingRight, paddingTop } = this.getPaddings();
            let calcLimit = limit;
            if (orientation === 'horizontal') {
                calcLimit -= paddingRight + paddingLeft;
            }
            else {
                calcLimit -= paddingTop + paddingBottom;
            }
            const diffMaxMin = max - min;
            const diffValMin = value - min;
            const percentage = diffValMin / diffMaxMin;
            let pos = Math.round(percentage * calcLimit);
            if (orientation === 'horizontal') {
                pos += reverse ? -paddingRight : paddingLeft;
            }
            else if (value === max) {
                pos = reverse ? calcLimit : paddingTop;
            }
            else if (percentage === 0) {
                pos = reverse ? paddingTop : calcLimit;
            }
            else {
                pos += reverse ? -paddingBottom : paddingTop;
            }
            return pos;
        };
        this.getValueFromPosition = (pos) => {
            const { grab, limit } = this.state;
            const { max, min, orientation, reverse, step } = this.props;
            const { paddingBottom, paddingLeft, paddingRight, paddingTop } = this.getPaddings();
            let calcPos = pos + grab;
            let calcLimit = limit;
            if (orientation === 'horizontal') {
                calcPos -= reverse ? paddingRight : paddingLeft;
                calcLimit -= paddingRight + paddingLeft;
            }
            else {
                calcPos -= reverse ? paddingBottom : paddingTop;
                calcLimit -= paddingTop + paddingBottom;
            }
            const percentage = clamp(calcPos, 0, calcLimit) / (calcLimit || 1);
            const baseVal = step * Math.round((percentage * (max - min)) / step);
            const value = orientation === 'horizontal' ? baseVal + min : max - baseVal;
            return clamp(value, min, max);
        };
        this.coordinates = (pos) => {
            const { limit } = this.state;
            const { max, orientation } = this.props;
            const value = this.getValueFromPosition(pos);
            const handlePos = this.getPositionFromValue(value);
            const fillPos = orientation === 'horizontal' ? handlePos : limit - handlePos;
            return {
                fill: value === max ? limit : fillPos,
                handle: handlePos,
                label: handlePos,
            };
        };
        this.getPaddings = () => {
            const node = this.fillRef;
            const { orientation } = this.props;
            if (orientation === 'horizontal') {
                const paddingLeft = this.getPaddingStyle(node, 'padding-left');
                const paddingRight = this.getPaddingStyle(node, 'padding-right');
                return {
                    paddingLeft,
                    paddingRight,
                };
            }
            const paddingTop = node
                ? parseInt(window.getComputedStyle(node, ':before').height, 10)
                : 0;
            const paddingBottom = node
                ? parseInt(window.getComputedStyle(node, ':after').height, 10)
                : 0;
            return {
                paddingBottom,
                paddingTop,
            };
        };
        this.getPaddingStyle = (node, name) => {
            if (!node) {
                return 0;
            }
            return parseInt(window.getComputedStyle(node, null).getPropertyValue(name), 10);
        };
    }
    render() {
        const { className, labels, max, min, orientation, reverse, showHandle, stepElement, tooltip, value, } = this.props;
        const { active, limit } = this.state;
        const { dimension } = constants.orientation[orientation];
        const direction = reverse
            ? constants.orientation[orientation].reverseDirection
            : constants.orientation[orientation].direction;
        const position = this.getPositionFromValue(value);
        const coords = this.coordinates(position);
        const fillBgWrapperStyle = { [dimension]: `${coords.fill}px` };
        const fillBgStyle = { [dimension]: `${limit}px` };
        const handleStyle = { [direction]: `${coords.handle}px` };
        const showTooltip = tooltip && active;
        let labelItems = [];
        let labelKeys = Object.keys(labels);
        if (labelKeys.length > 0) {
            labelKeys = labelKeys.sort((a, b) => (reverse ? a - b : b - a));
            labelItems = labelKeys.map((key) => {
                const labelPosition = this.getPositionFromValue(key);
                const labelCoords = this.coordinates(labelPosition);
                const labelStyle = { [direction]: `${labelCoords.label}px` };
                return (_jsx("li", Object.assign({ className: clsx('rangeslider__label-item'), "data-value": key, onMouseDown: this.handleDrag, onTouchEnd: this.handleEnd, onTouchStart: this.handleStart, style: labelStyle }, { children: this.props.labels[key] }), key));
            });
        }
        return (_jsxs("div", Object.assign({ "aria-orientation": orientation, "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value, className: clsx('rangeslider', `rangeslider-${orientation}`, { 'rangeslider-reverse': reverse }, className), onMouseDown: this.handleDrag, onMouseUp: this.handleEnd, onTouchEnd: this.handleEnd, onTouchStart: this.handleStart, ref: (s) => {
                this.slider = s;
            } }, { children: [_jsxs("div", Object.assign({ className: 'rangeslider__fill_wrapper' }, { children: [_jsx("div", Object.assign({ className: 'rangeslider__fill', ref: (sh) => {
                                this.fillRef = sh;
                            } }, { children: stepElement })), _jsx("div", Object.assign({ className: 'rangeslider__fill_bg_wrapper', style: fillBgWrapperStyle }, { children: _jsx("div", { className: 'rangeslider__fill_bg', style: fillBgStyle }) }))] })), _jsxs("div", Object.assign({ className: `rangeslider__handle ${showHandle ? '' : 'hide_handle'}`, onKeyDown: this.handleKeyDown, onMouseDown: this.handleStart, onTouchEnd: this.handleEnd, onTouchMove: this.handleDrag, ref: (sh) => {
                        this.handle = sh;
                    }, style: handleStyle, tabIndex: '0' }, { children: [showTooltip ? (_jsx("div", Object.assign({ className: 'rangeslider__handle-tooltip', ref: (st) => {
                                this.tooltip = st;
                            } }, { children: _jsx("span", { children: this.handleFormat(value) }) }))) : null, _jsx(HandleIcon, {})] })), labelItems.length > 0 ? this.renderLabels(labelItems) : null] })));
    }
}
InputRange.propTypes = Object.assign(Object.assign({}, Slider.propTypes), { showHandle: propBool().isRequired, stepElement: propChildren() });
export default InputRange;
